import List from './List';
import Detail from './Detail';
import {ReceptacleDialog} from '../Client/Cart/Detail';
import CN38 from './CN38';

const Components = {
    List : List,
    Detail : Detail,
    Receptacles : ReceptacleDialog,
    CN38
}

export default Components;